<template>
  <el-dialog
    v-if="boxshow"
    :visible.sync="boxshow"
    :title="title"
    :show-close="true"
    top="10vh"
    :close-on-click-modal="false"
    :modal="true"
    width="45%"
  >
    <!-- <div class="box-close" @click="closeBox">✗</div> -->
    <!-- <div class="box-title">
      <span style="font-size:20px;margin:10px;color:#606266">
        <slot name="title"></slot>
      </span>
      <el-divider style="margin-right:30px"></el-divider>
    </div> -->
    <div class="box-body">
      <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%">
        <el-form label-width="180px" label-position="right" ref="wxFormRef">
        </el-form>
        <slot name="cardForm"> </slot>
      </el-scrollbar>
    </div>

    <!-- <span >
      <el-button @click="centerDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="centerDialogVisible = false"
        >确 定</el-button
      >
    </span> -->

    <div slot="footer" class="dialog-footer" style="text-align:left;padding: 0 !important;">
      <slot name="btn_name"></slot>
      <!--  <el-button type="primary" plain style="margin-left:204px" @click="createCard">
        
      </el-button> -->
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "createCard",
  data() {
    return {
      boxshow: false
    };
  },
  props: {
    title: String
  },
  computed: {},
  mounted() {},
  methods: {
    openBox() {
      this.boxshow = true;
    },
    closeBox() {
      this.boxshow = false;
      this.$emit("closeCreateCard");
    },
    createCard() {
      console.log("点击保存");
    }
  }
};
</script>
<style scoped>
/* .dyh-dialog {
  width: 180vh;
  height: 180vh;
  background-color: rgb(255, 0, 0);
} */

.el-form {
  color: #9d9fa5;
}

.el-divider--horizontal {
  height: 0.1px;
  margin-top: 5px !important;
  margin-right: 30px !important;
  margin-bottom: 0 !important;
}

.card-father {
  /* transform: translate(-50%, -50%); */
  width: 99%;
  height: 99%;
}

.box-close {
  position: absolute;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  text-align: center;
  background-color: #fff;
  color: rgb(85, 85, 85);
  font-size: 26px;
  line-height: 1.2;
  border-bottom-left-radius: 3px;
  cursor: pointer;
  z-index: 99;
}

.box-close:hover {
  background-color: #fb7373;
  color: #fff;
}

.box-title {
  height: auto;
  width: 100%;
  padding-right: 30px;
}

.box-body {
  width: 100%;
  height: 400px;
}
.el-dialog__footer{
  padding: 0 !important;
}
</style>
